import { StarFourPointsBoxIcon } from './StarFourPointsBoxIcon';

/**
 * author: Jeff Anders
 * id 2DF46C9A-650D-486D-B242-36AD17F82227
 * name star-four-points-box
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-four-points-box.svg
 * tags
 * - Shape 
 */
export const AutoBoxIcon = StarFourPointsBoxIcon;
export default AutoBoxIcon